import { render } from "./TasksDragAndDrop.vue?vue&type=template&id=cd45e986"
import script from "./TasksDragAndDrop.vue?vue&type=script&lang=js"
export * from "./TasksDragAndDrop.vue?vue&type=script&lang=js"

import "./TasksDragAndDrop.vue?vue&type=style&index=0&id=cd45e986&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__